<template>
  <div class="fadeIn">
    <div v-if="loading" v-loading="loading"></div>
    <template v-else-if="user === 'new'">
      <div class="ra-auth--form__header">
        <h1>Invitation Accepted</h1>
        <p>
          {{ userData.organisation && userData.organisation.name }} has invited
          you to join their organisation.
        </p>
      </div>
      <div class="ra-auth--form__form">
        <el-form :model="form" label-position="top" ref="form" @submit.prevent>
          <el-row type="flex" :gutter="20" class="flex-wrap">
            <el-col :md="12">
              <el-form-item
                label="First name"
                prop="first_name"
                :rules="validateField('Firstname')"
              >
                <el-input
                  type="text"
                  v-model="form.first_name"
                  @keydown.enter.native="updateInvite"
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Last name"
                prop="last_name"
                :rules="validateField('Lastname')"
              >
                <el-input
                  type="text"
                  v-model="form.last_name"
                  @keydown.enter.native="updateInvite"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item
                label="Password"
                prop="password"
                :rules="validateField('Password')"
              >
                <el-input
                  type="password"
                  v-model="form.password"
                  show-password
                  @keydown.enter.native="updateInvite"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="ra-auth--form__actions">
        <el-button :loading="submitting" type="primary" @click="updateInvite"
          >Update</el-button
        >
      </div>
    </template>
    <template v-else>
      <div class="ra-auth--form__content">
        <img :src="getImage('check-solid.svg')" alt="Active" />
        <h2>Invitation Accepted</h2>
        <p>
          You have accepted the invitation to join <br />
          <span class="text-bold">{{
            userData.organisation && userData.organisation.name
          }}</span>
        </p>
        <el-button type="primary" plain :loading="redirecting"
          >Redirecting</el-button
        >
      </div>
    </template>
  </div>
</template>

<script>
import * as actions from "@/store/action-types";
export default {
  name: "Invite",
  data() {
    return {
      loading: false,
      user: "new",
      userData: {},
      form: {
        first_name: "",
        last_name: "",
        password: ""
      },
      submitting: false,
      redirecting: true
    };
  },
  created() {
    this.getInviteInfo();
  },
  methods: {
    getInviteInfo() {
      this.loading = true;
      const token = this.$route.params.token;

      this.$http
        .post("auth/verify/invite", {
          body: { ott: token },
          method: "POST"
        })
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.redirect("login");
          } else {
            this.userData = resData;
            const { user } = resData;
            const newUser = user.first_name && user.first_name === "-";

            if (newUser) {
              this.loading = false;
            } else {
              this.user = "existing";
              this.loading = false;
              this.$store.dispatch(actions.LOGIN, resData);
              this.redirect("home.index");
            }
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },
    updateInvite() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.updateUserInfo();
        this.updateUserPassword();
      });
    },
    updateUserInfo() {
      this.submitting = true;

      this.$http
        .post(
          `accounts/users/${this.userData.user.id}`,
          {
            body: {
              first_name: this.form.first_name,
              last_name: this.form.last_name
            },
            method: "PUT"
          },
          {
            headers: {
              "Api-Token": this.userData.auth_token
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.submitting = false;
          } else {
            this.userData = {
              ...this.userData,
              user: {
                ...resData.data
              }
            };
            this.$store.dispatch(actions.LOGIN, this.userData);
            this.notification(
              "Completed",
              "Your profile has been updated.",
              "success"
            );
            this.redirect("home.index");
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.submitting = false;
        });
    },
    updateUserPassword() {
      this.$http
        .post(
          `auth/local/password`,
          {
            body: { password: this.form.password },
            method: "POST"
          },
          {
            headers: {
              "Api-Token": this.userData.auth_token
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          }
        });
    },
    redirect(route) {
      setTimeout(() => {
        this.$router.push({ name: route });
      }, 1500);
    }
  }
};
</script>

<style scoped lang="scss">
.form-extras {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  a {
    font-size: 0.875rem;
  }
}

.ra-icon--eye-off::before,
.ra-icon--eye::before {
  cursor: pointer;
}

.ra-auth--form__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  img {
    height: 48px;
    width: 48px;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 1.35rem;
  }

  p {
    margin: 10px 0 20px;
  }
}
</style>
